import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import Laoding from '../shared/Laoding';


export default function DownloadFile(props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [file, setFile] = useState(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const targetRef1 = useRef(null);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    useEffect(() => {
        var params = {param1:token, param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/upload/file/url/get`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setFile(response);
                setLoading(false);
                console.log("response is>", response);
                
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLoading(false);
        });
    }, []);

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :        
        loading?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت مشخصات فایل..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        file == null?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    {errorMessage}
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px"}} ref={targetRef1}>
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}} colSpan={2}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}} colSpan={2}>پرتال مشتریان هانا</td>
                                </tr>
                                <tr><td colSpan={2}>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"ltr", border:"1px dashed #b0b0b0", padding:"5px"}} colSpan={2}>
                                        {file.mainFilename}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"rtl", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        سایز
                                    </td>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"ltr", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        {file.fileSize}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"rtl", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        فرستنده
                                    </td>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"ltr", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        {file.senderUser}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"rtl", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        شرکت
                                    </td>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"ltr", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        {file.senderCompany}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"rtl", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        ارسال
                                    </td>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"ltr", border:"1px dashed #b0b0b0", padding:"5px"}}>
                                        { util.toPersianDigits(util.SeperateDate(file.createDate)+", " + util.SeperateTime(file.createTime))}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"ltr", border:"1px dashed #b0b0b0", padding:"5px"}} colSpan={2}>
                                        {file.description}
                                    </td>
                                </tr>
                                <tr><td colSpan={2}>&nbsp;</td></tr>
                                <tr>
                                    <td colSpan={2} style={{textAlign:"center"}}>
                                        <a 
                                            href={file.url} 
                                            download={file.mainFilename}
                                            style={{
                                            display: 'inline-block',
                                            padding: '10px 20px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            textDecoration: 'none',
                                            borderRadius: '5px'
                                            }}
                                        >
                                            دانلود فایل
                                        </a>
                                    </td>
                                </tr>
                                <tr><td colSpan={2}>&nbsp;</td></tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}